import ReactDOM from "react-dom/client";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "assets/third-party/apex-chart.css";
import "assets/third-party/react-table.css";

// google-fonts
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConfigProvider } from "contexts/ConfigContext";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    {/* <GoogleOAuthProvider clientId="978617939898-in9pn9llehli9arv5k37q1ndio1i53j3.apps.googleusercontent.com"> */}
      <ConfigProvider>
        <App />
      </ConfigProvider>
    {/* </GoogleOAuthProvider> */}
  </>
);
